// @ts-nocheck
import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { ItemLineDetails, LoadingSkeleton, Reload } from 'sonata-react-components';

import { getCampaigns } from '@/store/selectors/reportingAdvancedFilter.selectors';
import { useCampaignPerformance } from '@/ts-contexts/reporting/Summary/useCampaignPerformance';
import { SummaryCampaignItemDetailsTableStyle } from './summaryCampaignItemDetailsTable.style';

import type { FilterSection } from '@/ts-types/reporting.types';

type Props = {
  filterSection: FilterSection;
};

export function SummaryCampaignItemDetailsTable({ filterSection }: Props) {
  const { formatMessage } = useIntl();
  const selectedCampaignIds: string[] = useSelector(getCampaigns);
  const { columns, inAnalytical, isError, isReady, items, onReload } = useCampaignPerformance({ filterSection });

  return (
    <SummaryCampaignItemDetailsTableStyle className="reportingCampaignItemDetailsTable">
      {isError && (
        <Reload
          className="reportingCampaignItemDetailsTableReload"
          id="reporting_reportingCampaignItemDetailsTable"
          onClickReload={onReload}
        />
      )}
      {!isReady && <LoadingSkeleton count={selectedCampaignIds.length + 3} height={50} width="100%" />}
      {isReady && (
        <ItemLineDetails
          emptyState={{
            title: formatMessage({
              defaultMessage: 'There are no campaigns matching the filters criteria',
              id: 'reporting.campaignItemDetails.emptyState.title'
            })
          }}
          id="reportingCampaignItemDetailsTable"
          includeCharts={inAnalytical}
          itemsLinesColumns={columns}
          itemsLinesData={items}
        />
      )}
    </SummaryCampaignItemDetailsTableStyle>
  );
}
